export default __webpack_public_path__ + "065c7c60494270201bf7e1aece03d908.svg";